import { type QuestionPStats } from '@exam-management/graphql';

export function getPStatId(pStat: QuestionPStats) {
  return `pUse-${pStat.pValue}-${pStat.calculatedAt.toISOString()}`;
}
